import userQueries from '@apis/queries/userQueries';
import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Switch from '@components/Switch';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import useBioDevice from './hooks/useBioDevice';
import useToggleLocationAgreement from './hooks/useToggleLocationAgreement';
import useToggleMarketingAgreement from './hooks/useToggleMarketingAgreement';

/**
 * 위치 정보, 마케팅 수신 동의
 * @constructor
 */
function Permissions() {
    const { t } = useTranslation('accountSetting');
    const { data: user } = useQuery(userQueries.detail());
    const toggleMarketingAgreement = useToggleMarketingAgreement();
    const { toggleLocationAgreement, locationAgreed } = useToggleLocationAgreement();
    const { isBioDevice, toggleBioDevice } = useBioDevice();
    const project = useProject();

    return (
        <Accordion title={t('permissions.title')}>
            <Contents fullWidth>
                <Switch label={t('permissions.locationAgreement')}
                    checked={locationAgreed}
                    setChecked={toggleLocationAgreement} />
                <Switch label={t('permissions.marketingAgreement')}
                    checked={user?.marketingAgreed}
                    setChecked={toggleMarketingAgreement} />
                {project?.features?.easyCardEnabled && (
                    <Switch label='생체인증'
                        checked={isBioDevice}
                        setChecked={toggleBioDevice} />
                )}
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: var(--spacing-2) 0 var(--spacing-4);
`;

export default Permissions;
